function e({bodySiteName:e,name:o,question:t,bodySiteGroup:a}){return a&&t?t.replaceAll("{{ bodySiteGroup }}",a.toLowerCase()).replaceAll("{{ bodySiteName }}",e.toLowerCase()):o}export{e as default};
